// extracted by mini-css-extract-plugin
module.exports = {"Banner":"StatusBanner_Banner__3dIwh","TrafficLights":"StatusBanner_TrafficLights__1-u02"};